import { AutocompleteRenderGetTagProps, Chip } from '@mui/material'
import { AssigneeAvatar, AssigneeAvatarOption } from './AssigneeAvatar'

interface AssigneeAutocompleteTagChipProps {
  option: AssigneeAvatarOption
  label: string
  getTagProps: AutocompleteRenderGetTagProps
  index: number
  isValid: boolean
}

export const AssigneeAutocompleteTagChip = ({ option, label, getTagProps, index, isValid }: AssigneeAutocompleteTagChipProps) => {
  return (
    <Chip
      avatar={<AssigneeAvatar option={option} sx={{ marginLeft: 1 }} />}
      label={label}
      size="small"
      {...getTagProps({ index })}
      key={index}
      data-testid={`assignee-chip-${option.value}`}
      color={!isValid ? 'error' : 'default'}
      variant="selection"
    />
  )
}
